"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthContext = exports.AuthContext = void 0;
// @ts-nocheck
const react_1 = require("react");
exports.AuthContext = react_1.createContext({
    clearToken: () => { },
    loginSuccess: () => { },
    loadExistingAuth: async () => {
        return undefined;
    },
    ready: false,
});
const useAuthContext = () => {
    const context = react_1.useContext(exports.AuthContext);
    if (!context) {
        throw new Error('useAuthContext should be used inside AuthContext.Provider');
    }
    return context;
};
exports.useAuthContext = useAuthContext;
//# sourceMappingURL=authContext.js.map